export default __webpack_public_path__ + "static/media/replyIcon.9ed48860.svg";